import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Link } from "gatsby";

const ThreeDPage = () => (
  <main style={{ backgroundColor: "#0a0a0a", minHeight: "100vh", color: "#fff" }}>
    <Header />
    <Footer />
  </main>
);

export default ThreeDPage;
